import { setRangeMin } from './helpers';

export const setMinLandArea = setRangeMin('site');
